///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'button[windeRed]',
    standalone: false
})
export class RedButtonDirective {
    @HostBinding('class') buttonClass = 'winde-button winde-button-with-text winde-red';
}
